
import SearchBar from '../components/SearchBar';
import Introduction from '../components/IntroductionText';
import ResultsError from '../components/ResultsErrorElement';
import Reminder from '../components/Reminder';
import Results from '../components/ResultsElement.vue';
import { nameCheckBoip, nameCheckKvk } from '@/client/client';
import ResultsIcon from '@/assets/icons/results.svg';
import NoResultsIcon from '@/assets/icons/no-results.svg';

export default {
    name: 'Search',
    components: {
        Introduction,
        SearchBar,
        Reminder,
        Results,
        ResultsError,
        ResultsIcon,
        NoResultsIcon,
    },
    data() {
        return {
            kvkResults: null,
            boipResults: null,
            lastSearchTerm: '',
            kvkHasError: false,
            boipHasError: false,
        };
    },
    computed: {
        hasSearched(): boolean {
            return !!(this.kvkResults || this.boipResults || this.hasErrors);
        },
        hasErrors(): boolean {
            return this.kvkHasError || this.boipHasError;
        },
        hasBoipResults(): boolean {
            return this.boipResults && this.boipResults.count > 0;
        },
        hasKvkResults(): boolean {
            return this.kvkResults && this.kvkResults.count > 0;
        },
        hasSearchResults(): boolean {
            return this.hasBoipResults || this.hasKvkResults;
        },
    },
    methods: {
        async searchName(name) {
            const kvkResponse = await nameCheckKvk(name);
            if (/error/i.test(kvkResponse) ||
                (kvkResponse.response &&
                    (/^4\d\d$|^5\d\d$/.test(kvkResponse.response.status) || /error/i.test(kvkResponse.response.status)))) {
                this.kvkHasError = true;
            } else {
                this.kvkHasError = false;
                this.kvkResults = kvkResponse;
            }

            const boipResponse = await nameCheckBoip(name);
            if (/error/i.test(boipResponse) ||
                (boipResponse.response &&
                    (/^4\d\d$|^5\d\d$/.test(boipResponse.response.status) || /error/i.test(boipResponse.response.status)))) {
                this.boipHasError = true;
            } else {
                this.boipHasError = false;
                this.boipResults = boipResponse;
            }

            this.lastSearchTerm = name;

            this.setBodyState();
        },

        setBodyState() {
            if (this.hasBoipResults && this.hasKvkResults) {
                document.body.removeAttribute('data-state');
                document.body.setAttribute('data-state', 'boip-kvk-results');
            } else if (this.hasBoipResults) {
                document.body.removeAttribute('data-state');
                document.body.setAttribute('data-state', 'boip-results');
            } else if (this.hasKvkResults) {
                document.body.removeAttribute('data-state');
                document.body.setAttribute('data-state', 'kvk-results');
            } else if (!this.hasBoipResults && !this.hasKvkResults) {
                document.body.removeAttribute('data-state');
                document.body.setAttribute('data-state', 'no-results');
            } else {
                document.body.removeAttribute('data-state');
            }
        },
    },
};
